
function initFormPassword(wrapper) {
    wrapper.classList.add('.maier-input-password-initialized');

    let input = wrapper.querySelector('input[type="password"], input[type="text"]');
    let icon = wrapper.querySelector('i.fa');
    let button = wrapper.querySelector('button');

    button.addEventListener('click', function () {
        icon.setAttribute('class', input.type === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye');
        input.type = input.type === 'password' ? 'text' : 'password';
    })
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.maier-input-password:not(.maier-input-password-initialized)').forEach(initFormPassword);
});

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length >= 1) {
            for (var i = 0; i < mutation.addedNodes.length; i++) {
                if (undefined !== mutation.addedNodes[i].localName) {
                    mutation.addedNodes[i].querySelectorAll('.maier-input-password:not(.maier-input-password-initialized)').forEach(initFormPassword);
                }
            }
        }
    });
});

observer.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });